import clsx from 'clsx';
import React from 'react';
import { useIntl } from 'react-intl';

import styles from './WgChip.module.scss';
import { ChipConfig } from './constants/chipConfiguration';

interface IWgConfigProps {
  config: ChipConfig;
  variant?: 'default' | 'rounded';
}

const WgChip: React.FunctionComponent<IWgConfigProps> = ({ config, variant }) => {
  const { labelTranslationKey, text, startIcon, endIcon, className } = config;

  const intl = useIntl();

  return (
    <div
      className={clsx(variant === 'rounded' ? styles.roundedChip : styles.chip, className)}
      data-testid="wg-chip-container"
    >
      {startIcon && <span className={styles.startIcon}>{startIcon}</span>}
      <span className={!startIcon && endIcon ? styles.textForEndIcon : undefined}>
        {labelTranslationKey
          ? intl.formatMessage({
              id: labelTranslationKey,
            })
          : text}
      </span>
      {endIcon && <span className={styles.endIcon}>{endIcon}</span>}
    </div>
  );
};

export default WgChip;
